const BASE_URL = process.env.REACT_APP_API_URL;
const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL;
const PAYMENT = process.env.REACT_APP_PAYMENT;

const EMAIL_REDIRECT_LINK = `${REDIRECT_URL}/redirect`;
const PASSWORD_RESET_REDIRECT_LINK = `${REDIRECT_URL}/password/reset`;
const CLIENT_ID = '1';
const CLIENT_SECRET = 'DEVPASSWORD12345';
const REGISTER = '/register';
const LOGIN = '/login';
const VEHICLES = '/vehicles';
const VEHICLE_TYPE = '/vehicles/type';
const VEHICLE_MAKE = '/vehicles/make';
const LICENSE = '/license';
const PROFILE = '/profile';
const USER = '/user';
const VERIFYING = 'email/verify';
const PAYMNENT_CARD = '/payment/cards';
const SUBSCRIPTION = '/subscription';
const CANCEL_SUBSCRIPTION = '/subscription/cancel';
const DOCUMENTS = '/documents';
const SOLUTION_FOR_BUSINESS = '/business-member';
// const ADD_EXTRA_DRIVER = '/driver'
const DOWNLOAD_INVOICE = '/subscription/invoice';
const DOWNLOAD_CONTRACT = '/subscription/contract';
const CONTACT_US = '/contact';
const FEEDBACK = '/feedback';
const FORGOT_PASSWORD = '/password/forgot';
const RESET_PASSWORD = '/password/reset';
const ENQUIRY = '/enquiry';
const EMPLOYEE_INFO = '/employee-info';
const ID_CARD = '/identity-card';
const DECLARATION = '/declaration';
const MANUAL_PAY = '/subscription/manual';
const LOANS = '/declaration/loan';
const RELATIONSHIP = '/declaration/relationship';
const UPDATE_LIVING_EXPENSE = '/declaration/living-expense';
const CHANGE_PASSWORD = '/password/change';
export {
    BASE_URL,
    CLIENT_ID,
    CLIENT_SECRET,
    PAYMENT,
    REGISTER,
    LOGIN,
    VEHICLES,
    VEHICLE_MAKE,
    VEHICLE_TYPE,
    LICENSE,
    PROFILE,
    USER,
    PAYMNENT_CARD,
    SUBSCRIPTION,
    DOCUMENTS,
    SOLUTION_FOR_BUSINESS,
    DOWNLOAD_INVOICE,
    CONTACT_US,
    FEEDBACK,
    EMPLOYEE_INFO,
    ID_CARD,
    FORGOT_PASSWORD,
    RESET_PASSWORD,
    ENQUIRY,
    VERIFYING,
    DECLARATION,
    MANUAL_PAY,
    LOANS,
    RELATIONSHIP,
    UPDATE_LIVING_EXPENSE,
    DOWNLOAD_CONTRACT,
    EMAIL_REDIRECT_LINK,
    CANCEL_SUBSCRIPTION,
    PASSWORD_RESET_REDIRECT_LINK,
    CHANGE_PASSWORD,
    REDIRECT_URL,
};
